// Consent text is HTML from the Sales App's CKEditor. Keep only simple formatting
// tags so nothing executable can reach the page.
const ALLOWED_TAGS = new Set([
	"P", "BR", "B", "STRONG", "I", "EM", "U", "UL", "OL", "LI",
	"H1", "H2", "H3", "H4", "H5", "H6", "BLOCKQUOTE", "A", "SPAN",
]);

function clean(node, doc) {
	[...node.childNodes].forEach((child) => {
		if (child.nodeType === Node.TEXT_NODE) return;
		if (child.nodeType !== Node.ELEMENT_NODE || !ALLOWED_TAGS.has(child.tagName)) {
			// Drop the tag but keep its text (scripts/styles are dropped entirely)
			if (child.nodeType === Node.ELEMENT_NODE && !["SCRIPT", "STYLE", "IFRAME", "OBJECT"].includes(child.tagName)) {
				clean(child, doc);
				child.replaceWith(...child.childNodes);
			} else {
				child.remove();
			}
			return;
		}
		const href = child.tagName === "A" ? child.getAttribute("href") : null;
		[...child.attributes].forEach((attr) => child.removeAttribute(attr.name));
		if (href && /^(https?:|mailto:)/i.test(href.trim())) {
			child.setAttribute("href", href.trim());
			child.setAttribute("target", "_blank");
			child.setAttribute("rel", "noopener noreferrer");
		}
		clean(child, doc);
	});
}

export function sanitizeConsentHtml(html) {
	if (!html) return "";
	const doc = new DOMParser().parseFromString(String(html), "text/html");
	clean(doc.body, doc);
	return doc.body.innerHTML;
}
